import { useState } from "react";
import style from "./ContactUs.module.css";
import { sendContactEmail } from "../../services/emailjsContact";
import { validateContactForm } from "../../services/contactValidation";

const EMPTY_FORM = { name: "", email: "", phone: "", subject: "", message: "" };

export default function ContactUs() {
  const [form, setForm] = useState(EMPTY_FORM);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);

  // Reusable field change handler
  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: undefined }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitted(false);

    // 1. Validate before submission
    const validationErrors = validateContactForm(form);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // 2. Disable button + show loading
    setSending(true);

    try {
      // 3. Send email via EmailJS
      try {
        await sendContactEmail(form);
      } catch (emailErr) {
        console.error("EmailJS send failed:", emailErr);
        const detail =
          emailErr && emailErr.text
            ? emailErr.text
            : emailErr && emailErr.message
              ? emailErr.message
              : "";
        throw new Error(`Email send failed: ${detail || emailErr}`);
      }

      // 4. Email sent successfully
      setSubmitted(true);
      setForm(EMPTY_FORM);
      setErrors({});
      setTimeout(() => setSubmitted(false), 3000);
    } catch (err) {
      // 5. Any failure
      console.error("Contact submission failed:", err);
      const detail = err && err.message ? err.message : String(err);
      setError(`Something went wrong. ${detail}`);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contact">
      <div className={style.contactHero}>
        <div className="container">
          <h2>Contact</h2>
          <h1>Vyra Pharma</h1>
          <p>We're here to support healthcare professionals and partners</p>
        </div>
      </div>

      <div className="container">
        <div className={style.contactContainer}>
          <div className={style.contactInfo}>
            <h2>Get in Touch</h2>
            <p
              style={{ marginBottom: "24px", color: "var(--color-text-light)" }}
            >
              Reach out to us for product enquiries, partnerships, or any
              questions.
            </p>

            <div className={style.infoBox}>
              <h4>Address</h4>
              <p>Vyra Pharmaceuticals Pvt. Ltd.</p>
              <p>M/1 West Chowbhaga</p>
              <p>LP-14/43/4, Kolkata-700100</p>
              <p>West Bengal, India</p>
            </div>

            <div className={style.infoBox}>
              <h4>Phone</h4>
              <p>+91 9288544134</p>
            </div>

            <div className={style.infoBox}>
              <h4>Email</h4>
              <p>vyrapharma@gmail.com</p>
            </div>
          </div>

          <form
            className={style.contactForm}
            onSubmit={handleSubmit}
            noValidate
          >
            <h2>Send Message</h2>

            {submitted && (
              <div className={style.successMsg}>
                Thank you! Your message has been sent successfully.
              </div>
            )}

            {error && <div className={style.errorMsg}>{error}</div>}

            <div className={style.formGroup}>
              <div className={style.fieldWrap}>
                <input
                  type="text"
                  placeholder="Your Name"
                  value={form.name}
                  onChange={handleChange("name")}
                />
                {errors.name && (
                  <span className={style.fieldError}>{errors.name}</span>
                )}
              </div>
              <div className={style.fieldWrap}>
                <input
                  type="email"
                  placeholder="Email Address"
                  value={form.email}
                  onChange={handleChange("email")}
                />
                {errors.email && (
                  <span className={style.fieldError}>{errors.email}</span>
                )}
              </div>
            </div>

            <div className={style.formGroup}>
              <div className={style.fieldWrap}>
                <input
                  type="text"
                  placeholder="Phone Number"
                  value={form.phone}
                  onChange={handleChange("phone")}
                />
                {errors.phone && (
                  <span className={style.fieldError}>{errors.phone}</span>
                )}
              </div>
              <div className={style.fieldWrap}>
                <input
                  type="text"
                  placeholder="Subject"
                  value={form.subject}
                  onChange={handleChange("subject")}
                />
                {errors.subject && (
                  <span className={style.fieldError}>{errors.subject}</span>
                )}
              </div>
            </div>

            <div className={style.fieldWrap}>
              <textarea
                placeholder="Your Message"
                rows="5"
                value={form.message}
                onChange={handleChange("message")}
              ></textarea>
              {errors.message && (
                <span className={style.fieldError}>{errors.message}</span>
              )}
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: "100%" }}
              disabled={sending}
            >
              {sending ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>

        <div className={style.mapSection}>
          <iframe
            title="Vyra Pharma Location"
            src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3685.3165231119697!2d88.40893967475596!3d22.52981283453824!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sM%2F1%20West%20Chowbhaga%20%20LP-14%2F43%2F4%2C%20Kolkata-700100!5e0!3m2!1sen!2sin!4v1775757851366!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0, borderRadius: "var(--radius-lg)" }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  );
}
